import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Spin } from "antd";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import dayjs from "dayjs";
import { App } from "@/app";
import reportWebVitals from "./reportWebVitals";
import "./shared/styles/index.css";
import "./services/i18n";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <Suspense fallback={<Spin />}>
      <App />
    </Suspense>
  </React.StrictMode>,
);

reportWebVitals();
